import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

/*
  Non-stock delta (see docs/frontend-conventions.md): the app has no dark mode,
  so this drops the stock `next-themes` dependency and pins the light theme.
  Toasts keep the brand `bottom-center` position and the brand *colored* design
  (`unstyled` sonner + brand classNames — solid brand-colored pill, white text,
  X in a divided cell) instead of the stock white popover look. Re-apply on
  `shadcn diff`.
*/
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      position="bottom-center"
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--width": "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        } as React.CSSProperties
      }
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "mx-5 text-white min-h-12 rounded-lg grid grid-cols-[auto_1fr_auto_auto] pl-2 overflow-hidden",
          content: "py-2 pr-4 text-sm flex items-center justify-center",
          icon: "h-full! w-auto! flex items-center justify-center pl-3 pr-3",

          // Buttons
          actionButton:
            "w-12 flex items-center justify-center border-l border-white/20 hover:bg-black/10",
          cancelButton:
            "w-12 flex items-center justify-center border-l border-white/20 hover:bg-black/10",

          // Copy
          title: "leading-6 font-normal",
          description: "leading-6 font-normal",

          // Toast colors (brand tokens)
          success: "bg-primary-500",
          warning: "bg-system-warning",
          error: "bg-system-error",
          info: "bg-secondary-600",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
